import { z } from 'zod';

export const CreateUserFormSchema = z.object({
    name: z
        .string({
            message: 'Name is required!',
        })
        .min(1)
        .max(100),
    email: z
        .string({
            message: 'Email is required!',
        })
        .email({
            message: 'Enter valid email!',
        }),
    password: z
        .string({
            message: 'Password is required!',
        })
        .min(6, {
            message: 'Password at least 6 characters!',
        }),
    phone_number: z.string(),
    role_id: z.string({
        message: 'Role id is required!',
    }),

    status: z.enum(['active', 'suspended']),
});

export type TCreateUserForm = z.infer<typeof CreateUserFormSchema>;

export const UpdateUserFormSchema = CreateUserFormSchema.extend({
    password: z.string().optional(),
});

export type TUpdateUserForm = z.infer<typeof UpdateUserFormSchema>;

export const INITIAL_VALUES: Partial<TCreateUserForm> = {
    name: '',
    email: '',
    password: '',
    phone_number: '',
    role_id: '',
    status: 'active',
};
